import { HttpHandler } from 'msw'

import { orders } from './orders'

export const operations: HttpHandler[] = [...orders]
